export default __webpack_public_path__ + "static/media/missing_info.b3e9c1ce.png";